import store from '../../../core/store';

export const listProjectStages = (project_id) => {
  return store.dispatch({
    action: 'table.stages/LIST_PROJECT_STAGES',
    method: 'GET',
    endpoint: '/projects/' + project_id + '/stages',
    main: true,
  });
};

export const listProjectSubstages = (project_id) => {
  return store.dispatch({
    action: 'table.stages/LIST_PROJECT_SUBSTAGES',
    method: 'GET',
    endpoint: '/projects/' + project_id + '/stages/substages',
    main: true,
  });
};

export const filterProjectSubstages = () => {
  return store.dispatch({
    type: 'table.stages/FILTER_PROJECT_SUBSTAGES',
  });
};

export const listProjectSubstagesSchedule = (project_id) => {
  return store.dispatch({
    action: 'table.project_planning/LIST_PROJECT_SUBSTAGES_SCHEDULE',
    method: 'GET',
    endpoint: '/projects/' + project_id + '/stages/substages/schedule',
  });
};

export const createProjectPlanningTemplate = (projectId, formData) => {
  return store.dispatch({
    action: 'table.stages/CREATE_PROJECT_PLANNING_TEMPLATE',
    method: 'POST',
    endpoint: `/projects/${projectId}/planning-templates`,
    data: formData,
  });
};

export const loadProjectPlanningTemplate = (
  projectId,
  templateId,
  formData,
) => {
  return store.dispatch({
    action: 'table.stages/LOAD_PROJECT_PLANNING_TEMPLATE',
    method: 'POST',
    endpoint: `/projects/${projectId}/planning-templates/${templateId}/load`,
    data: formData,
  });
};

export const listProjectPlanningLibraryItems = (projectId, type) => {
  return store.dispatch({
    action: 'table.stages/LIST_PROJECT_PLANNING_LIBRARY_ITEMS',
    method: 'GET',
    endpoint: `/projects/${projectId}/planning-library-items?type=${type}`,
  });
};

export const updateStageStatus = (stage_id, status) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_STAGE_STATUS',
    method: 'PUT',
    endpoint: '/stages/' + stage_id + '/status',
    data: {
      status,
    },
  });
};

export const updateSubstageStatus = (substage_id, status) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_SUBSTAGE_STATUS',
    method: 'PUT',
    endpoint: '/substages/' + substage_id + '/status',
    data: {
      status,
    },
  });
};

export const updateStageCurrent = (stage_id) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_STAGE_CURRENT',
    method: 'PUT',
    endpoint: '/stages/' + stage_id + '/current',
  });
};

export const updateStageOrder = (stage_id, direction) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_STAGE_ORDER',
    method: 'PUT',
    endpoint: '/stages/' + stage_id + '/order',
    data: {
      direction,
    },
  });
};

export const readStage = (stage_id) => {
  return store.dispatch({
    action: 'table.stages/READ_STAGE',
    method: 'GET',
    endpoint: '/stages/' + stage_id,
  });
};

export const getStageDefaultVisibility = (stage_id) => {
  return store.dispatch({
    action: 'table.stages/GET_STAGE_DEFAULT_VISIBILITY',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/default_visibility',
  });
};

export const updateStage = (stage_id, formData) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_STAGE',
    method: 'PUT',
    endpoint: '/stages/' + stage_id,
    data: formData,
  });
};

export const getStagesPermissions = (project_id) => {
  return store.dispatch({
    action: 'table.stages/GET_STAGE_PERMISSIONS',
    method: 'GET',
    endpoint: '/projects/' + project_id + '/permissions',
  });
};

export const validateStageDetails = (formData) => {
  return store.dispatch({
    action: 'table.stages/VALIDATE_STAGE_DETAILS',
    method: 'POST',
    endpoint: '/stages/stage_details',
    data: formData,
  });
};

export const validateStageDiscipline = (formData) => {
  return store.dispatch({
    action: 'table.stages/VALIDATE_STAGE_DISCIPLINE',
    method: 'POST',
    endpoint: '/stages/stage_discipline',
    data: formData,
  });
};

export const createStage = (project_id, formData) => {
  return store.dispatch({
    action: 'table.stages/CREATE_STAGE',
    method: 'POST',
    endpoint: '/projects/' + project_id + '/stages',
    data: formData,
  });
};

export const getStagesLanguages = (stage_id) => {
  return store.dispatch({
    action: 'table.stages/GET_STAGE_LANGUAGES',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/languages',
  });
};

export const updateStageToolbar = (stage_id, formData) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_STAGE_TOOLBAR',
    method: 'PUT',
    endpoint: '/stages/' + stage_id + '/toolbar',
    data: formData,
  });
};

export const updateSubstageToolbar = (substage_id, formData) => {
  return store.dispatch({
    action: 'table.stages/UPDATE_SUBSTAGE_TOOLBAR',
    method: 'PUT',
    endpoint: '/substages/' + substage_id + '/toolbar',
    data: formData,
  });
};

export const readProjectPerformance = (project_id) => {
  return store.dispatch({
    action: 'table.stages/READ_PROJECT_PERFORMANCE',
    method: 'GET',
    endpoint: '/projects/' + project_id + '/performance',
  });
};
